module.exports = __webpack_public_path__ + "img/202601_01.7053fa86.png";